var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" topup2 "),_vm._l((_vm.products),function(item){return _c('div',{key:item.price},[_c('docket',{attrs:{"name":item.name,"amount":item.price,"code":item.stripeCode}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }